import { FieldErrors, UseFormRegister } from 'react-hook-form'
import type { FieldValues } from './RecipientsInformation'

const AWelcomeMessageFromYouToTheRecipient = ({
  errors,
  register,
}: {
  errors: FieldErrors<FieldValues>
  register: UseFormRegister<FieldValues>
}) => (
  <div>
    <fieldset className="form-item">
      <legend>
        <span>A welcome message from you to the recipient</span>
      </legend>
      <div>
        <div className="form-item">
          <div>
            <textarea
              className="form-textarea"
              cols={60}
              id="edit-message"
              rows={5}
              {...register('message', {
                validate: (value) => {
                  if (value && value.length > 250) {
                    return 'Field is limited to 250 characters'
                  }
                  return undefined
                },
              })}
            ></textarea>
            {errors.message && (
              <div className="form-item--error-message">
                {errors.message.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </fieldset>
  </div>
)

export default AWelcomeMessageFromYouToTheRecipient
